let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("49MQd")).then(() => parcelRequire('5V0di'));